var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useEffect, useMemo, useState } from '@max/max';
import View from '@hfe/max-view';
import './index.scss';
import App from './views/App';
import { useCardData } from './hooks/useCardData';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { setRemConfig } from '@max/leez-style-util';
import Sensor from '@max/mbc-sensor';
import { BID } from './const/bid';
const DEFAULT_CITY_ID = 1;
const MyComponent = (props) => {
    var _a, _b, _c;
    useMemo(() => {
        setRemConfig({
            enabled: true
        });
    }, []);
    // 从全局变量global取Context
    const ctx = useMonitorEngineContext();
    const [pageNo, setPageNo] = useState(0);
    const [cityId, setCityId] = useState((_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.cityId) !== null && _c !== void 0 ? _c : DEFAULT_CITY_ID);
    // 构建上报数据
    const uid = ctx === null || ctx === void 0 ? void 0 : ctx._moduleId;
    const moduleType = "max-comprehensive-card";
    const pageId = (ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo.pageId) || "-999";
    const texReportData = {
        tex_id: pageId,
        module_type: moduleType,
        instance_id: uid
    };
    // 使用统一的数据加载 Hook
    const { cardList, showLoadMore, loadMore: handleLoadMore, cityChangeCallback } = useCardData({
        styleType: props.cardStyleType,
        cityId,
        props,
        texReportData,
        ctx
    });
    // 监听城市变化事件
    useEffect(() => {
        var _a;
        const handleCityChange = (city) => {
            if (city === null || city === void 0 ? void 0 : city.value) {
                setCityId(Number(city.value));
                cityChangeCallback(Number(city.value));
            }
        };
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', handleCityChange);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('cityChanged', handleCityChange);
        };
    }, []);
    return <Sensor onAppear={() => {
            ctx === null || ctx === void 0 ? void 0 : ctx._LXReport.mvReport(BID.OVERALL_MV);
        }}>
      <View>
        <App {...props} cardList={cardList} loadMore={handleLoadMore} texReportData={texReportData} showLoadMore={showLoadMore} ctx={ctx} styleType={props.cardStyleType} firstPageRows={props.firstPageRows} topTagText={props.topTagText} topTagShowCount={props.topTagShowCount}/>
      </View>
      {/* <Text onClick={() => {
          const city = {
            value: 55,
          }
          console.log('监听到城市变化', city);
          if (city?.value) {
            setCityId(Number(city.value));
            cityChangeCallback(Number(city.value));
          }
         }}>切换城市</Text> */}
    </Sensor>;
};
export default memo(MyComponent);
export function _customPVReportParams(params) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        return {
            custom: {
                hotel_channel: ((_a = params === null || params === void 0 ? void 0 : params.queryParams) === null || _a === void 0 ? void 0 : _a['hotelchannel']) || '-999',
                tex_id: ((_b = params === null || params === void 0 ? void 0 : params.queryParams) === null || _b === void 0 ? void 0 : _b['pageId']) || '-999'
            }
        };
    });
}
